// npm packages
import React, { Fragment, useState } from "react";
import { useNavigate } from "react-router-dom";

// material ui
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Card from "@mui/material/Card";
import ListSubheader from "@mui/material/ListSubheader";

// custom pages
import RpAllowance from "./rpAllowance/RpAllowance";
import RpAllowanceSummary from "./rpAllowance/RPAllowanceSummary";
import RadScheduleForecast from "./RadScheduleForecast";
import RadScheduleForecastArchive from "./RadScheduleForecastArchive";
import RadScheduleActual from "./RadScheduleActual";
import VraMonthlySchedule from "./VraMonthlySchedule";
import RadRosterReport from "./RadRosterReport";
import VraRosterReport from "./VraRosterReport";
import VraRadAffinity from "./VraRadAffinity";
import leftarrow from "assets/images/arrow-right.png";
import RadScheduleForecastCalenderView from "./RadScheduleForecastCalenderView";
import VraMonthlyScheduleForecastCalendar from "./VraMonthlyScheduleForecastCalendar";
import Accession from "./Accession";
import VraRadPoolReport from "./VraRadPoolReport";
import VraMonthlyScheduleForecast from "./VraMonthlyScheduleForecastReport";
import VraMonthlyScheduleForecastRadCalendar from "./VraMonthlyScheduleForecastRadCalendar";
// import QualityAnalysisReport from "./QualityAnalysisReport";
import QualityAnalysisDetailedReport from "./QualityAnalysisDetailedReport";
import QualityCompletionReport from "./QualityCompletionReport";
import QualityErrorAnalysisReport from "./QualityErrorAnalysisReport";
import PoolPrepRosterReport from "./PoolPrepRosterReport";
import AtcRosterReport from "./AtcRosterReport";

export default function RPreports() {
  const [disableDropdown, setDisableDropdown] = useState(false);
  const [currentReport, setCurrentReport] = useState(1);
  const navigate = useNavigate();

  const handleNavigation = () => {
    navigate("/panel/rpHomePage");
  };

  const reports2 = {
    "Allowance Reports": [
      {
        id: 1,
        reportName: "RP Allowance Report",
      },
      {
        id: 2,
        reportName: "RP Allowance Report Summary",
      },
    ],
    "RAD Reports": [
      {
        id: 8,
        reportName: "RP RAD Roster Report",
      },
      {
        id: 3,
        reportName: "RP RAD Schedule Report Forecast",
      },
      {
        id: 11,
        reportName: " RP RAD Schedule Forecast Calender View",
      },
      { id: 9, reportName: "RP RAD Schedule Forecast Archive Report" },
      {
        id: 4,
        reportName: "RP RAD Schedule Report Actual",
      },
    ],
    "VRA Reports": [
      {
        id: 7,
        reportName: "RP VRA Roster Report",
      },
      {
        id: 5,
        reportName: "RP VRA Monthly Schedule Report",
      },
      {
        id: 12,
        reportName: "RP VRA Monthly Schedule Forecast Calendar",
      },
      {
        id: 16,
        reportName: "RP VRA Monthly Schedule Forecast Calendar (RAD View)",
      },
      {
        id: 15,
        reportName: "RP VRA Schedule Report",
      },
       {
        id: 20,
        reportName: "RP Pool Prep Roster Report",
      },
       {
        id: 21,
        reportName: "RP ATC Roster Report",
      },
    ],
    "Affinity Reports": [
      {
        id: 10,
        reportName: "RP VRA RAD Affinity Report",
      },
      {
        id: 14,
        reportName: "RP VRA RAD Pool Report",
      },
    ],
    "Quality Reports": [
      {
        id: 13,
        reportName: "RP Accession Report",
      },
      {
        id: 17,
        reportName: "RP Quality Error Analysis Report", 
      },
      {
        id: 18,
        reportName: "RP Quality Analysis Detailed Report",
      },
      {
        id: 19,
        reportName: "RP Quality Completion Report",
      },
      
    ],
  };

  // const reports = [
  //   {
  //     id: 1,
  //     reportName: "RP Allowance Report",
  //   },

  //   {
  //     id: 2,
  //     reportName: "RP Allowance Report Summary",
  //   },
  //   {
  //     id: 3,
  //     reportName: "RP RAD Schedule Report Forecast",
  //   },
  //   {
  //     id: 11,
  //     reportName: " RP RAD Schedule Forecast Calender View",
  //   },
  //   {
  //     id: 4,
  //     reportName: "RP RAD Schedule Report Actual",
  //   },
  //   {
  //     id: 5,
  //     reportName: "RP VRA Monthly Schedule Report ",
  //   },
  //   {
  //     id: 12,
  //     reportName: "RP VRA Monthly Schedule Forecast Calendar",
  //   },
  //   // {
  //   //   id: 6,
  //   //   reportName:"RP VRA Monthly Schedule Report Summary",
  //   // },
  //   {
  //     id: 7,
  //     reportName: "RP VRA Roster Report",
  //   },
  //   {
  //     id: 8,
  //     reportName: "RP RAD Roster Report",
  //   },
  //   { id: 9, reportName: "RP RAD Schedule Forecast Archive Report" },
  //   {
  //     id: 10,
  //     reportName: "RP VRA RAD Affinity Report",
  //   },
  //   {
  //     id: 13,
  //     reportName: "RP Accession Report",
  //   },
  //   {
  //     id: 14,
  //     reportName: "VRA RAD Pool Report",
  //   },
  //   {
  //     id: 15,
  //     reportName: "VRA Monthly Schedule Forecast Report",
  //   },
  // ];

  function setReports(tab) {
    switch (tab) {
      case 1:
        return <RpAllowance setDisableDropdown={setDisableDropdown} />;
      case 2:
        return <RpAllowanceSummary setDisableDropdown={setDisableDropdown} />;
      case 3:
        return <RadScheduleForecast setDisableDropdown={setDisableDropdown} />;
      case 4:
        return <RadScheduleActual setDisableDropdown={setDisableDropdown} />;
      case 5:
        return <VraMonthlySchedule setDisableDropdown={setDisableDropdown} />;
      // case 6:
      //   return <VraMonthlyScheduleReportSummary setDisableDropdown={setDisableDropdown} />;
      case 7:
        return <VraRosterReport setDisableDropdown={setDisableDropdown} />;
      case 8:
        return <RadRosterReport setDisableDropdown={setDisableDropdown} />;
      case 9:
        return (
          <RadScheduleForecastArchive setDisableDropdown={setDisableDropdown} />
        );
      case 10:
        return <VraRadAffinity setDisableDropdown={setDisableDropdown} />;
      case 11:
        return (
          <RadScheduleForecastCalenderView
            setDisableDropdown={setDisableDropdown}
          />
        );
      case 12:
        return (
          <VraMonthlyScheduleForecastCalendar
            setDisableDropdown={setDisableDropdown}
          />
        );
      case 13:
        return <Accession setDisableDropdown={setDisableDropdown} />;
      case 14:
        return <VraRadPoolReport setDisableDropdown={setDisableDropdown} />;
      case 15:
        return (
          <VraMonthlyScheduleForecast setDisableDropdown={setDisableDropdown} />
        );
        case 16:
          return (
            <VraMonthlyScheduleForecastRadCalendar setDisableDropdown={setDisableDropdown} />
          );
          case 17:
          return (
            <QualityErrorAnalysisReport setDisableDropdown={setDisableDropdown} />
          );
          case 18:
          return (
            <QualityAnalysisDetailedReport setDisableDropdown={setDisableDropdown} />
          );
          case 19:
            return (
              <QualityCompletionReport setDisableDropdown={setDisableDropdown} />
            );
            case 20:
            return (
              <PoolPrepRosterReport setDisableDropdown={setDisableDropdown} />
            )
            case 21:
            return (
              <AtcRosterReport setDisableDropdown={setDisableDropdown} />
            )
      default:
        return;
    }
  }

  return (
    <Card variant="outlined" sx={{ padding: "30px", borderRadius: "10px" }}>
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <div onClick={handleNavigation} style={{ cursor: "pointer" }}>
            <img src={leftarrow} alt="Back" />
          </div>
          <Box className="label">Select a Report</Box>
        </div>
      </Grid>
      <Grid container>
        <Grid item xs={12} sm={6} md={4} lg={4}>
          <FormControl fullWidth>
            <Select
              id="maritalStatus"
              placeholder="Select ID Proof"
              inputProps={{ "aria-label": "Without label" }}
              disabled={disableDropdown}
              value={currentReport}
              onChange={(e) => {
                setCurrentReport(e.target.value);
              }}
              renderValue={(selectedId) => {
                const selectedReport = Object.values(reports2)
                  .flat() 
                  .find((report) => report.id === selectedId);
                return selectedReport
                  ? selectedReport.reportName
                  : "Select a report";
              }}
            >
              {/* {reports.map((report, index) => (
                <MenuItem key={index} value={report.id}>
                  {report.reportName}
                </MenuItem>
              ))} */}
              {Object.keys(reports2)?.map((key, i) => [
                <ListSubheader
                  key={`header-${i}`}
                  style={{
                    fontWeight: "bold",
                    borderBottom: "2px solid",
                    background: "rgb(202 200 200)",
                  }}
                >
                  {key}
                </ListSubheader>,
                reports2?.[key]?.map((obj, j) => (
                  <MenuItem value={obj.id} key={j}>
                    &nbsp;&nbsp;{j+1}. {obj.reportName}
                  </MenuItem>
                )),
              ])}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <div>{setReports(currentReport)}</div>
    </Card>
  );
}
